<template>
    <div class="field is-horizontal adv-search-btns">

        <div class="field-body">
            <div class="field">
                <div class="control">
                    <button class="button is-danger is-fullwidth" :class="{ 'is-loading' : isLoading }" @click="submitForm">
                        Search
                    </button>
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <button class="button is-fullwidth" :class="{ 'is-loading' : isLoading }" @click="clearForm">
                        Clear
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            isLoading() {
                return this.$store.getters.getSearchResultsLoadingStatusStock
            }
        },
        methods: {
            submitForm() {
                if (this.$store.getters.getStatsStatusStock) {
                    this.$store.dispatch('setSearchQueryPageNumberStock', 1)
                    this.$store.dispatch('setStatsQueryFieldValueStock', {field: 'limit_start', value: 0})
                    this.$store.dispatch('setStatsQueryFieldValueStock', {field: 'limit_end', value: 30})
                    this.$store.dispatch('mergeStatsQueryWithSearchStock', this.$store.getters.getQueryStock)
                    this.$store.dispatch('setResultOrderColumnStock', 'auct_date')
                    this.$store.dispatch('fetchPastResult')
                } else {
                    this.$store.dispatch('setResultOrderColumnStock', 'auct_date')
                    this.$store.dispatch('setSearchQueryPageNumberStock', 1)
                    this.$store.dispatch('fetchStockCars')
                }
                /*if (document.documentElement.clientWidth < 450) {
                    document.getElementById('table').scrollIntoView()
                }*/
                this.$router.push({path: 'buy-now', query: {page: 1, action: 'search'}})
            },
            clearForm() {
                this.$store.dispatch('setQueryToDefaultStock')
                this.$store.dispatch('setModelsToDefaultStock')
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/StockCars/SearchStockCar.vue